import React from 'react'
import { Link } from 'react-router-dom'

export default function ImageHeader({imageHead}) {
  return (
    <>
    <section className="image-subhead">
        <div className="container">
            <div className="row align-items-end">
                <div className="col-lg-4 col-md-4">
                    <ul>
                        <li><Link to={"/"}>Home</Link></li>
                        {imageHead?.breadcrumb?.map((data, index) => (
                            <li key={index}>
                                {data.slug ? (
                                <Link to={data.slug}>{data.name}</Link>
                                ) : (
                                data.name
                                )}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="col-lg-4 col-md-4">
                    <p dangerouslySetInnerHTML={{ __html: imageHead.title }} />
                </div>
            </div>
        </div>

        <img src={imageHead.image} className='img-responsive' alt="banner" />
    </section>
    </>
  )
}
